module.exports = __webpack_public_path__ + "static/media/team-holly.52e91bb1.jpg";